type PerfMark = {
  name: string;
  t: number;
  data?: Record<string, unknown>;
};

type PerfNav = {
  id: string;
  label: string;
  startedAt: number;
  marks: PerfMark[];
};

declare global {
  interface Window {
    __LLX_PERF__?: {
      current?: PerfNav;
      history: PerfNav[];
    };
  }
}

const getStore = () => {
  if (!window.__LLX_PERF__) {
    window.__LLX_PERF__ = { history: [] };
  }
  return window.__LLX_PERF__;
};

const now = () => Math.round(performance.now() * 100) / 100;

const makeId = () => `${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;

export const navPerf = {
  start(label: string, data?: Record<string, unknown>) {
    const store = getStore();
    const nav: PerfNav = {
      id: makeId(),
      label,
      startedAt: now(),
      marks: [{ name: "start", t: now(), data }],
    };
    store.current = nav;
    // Single-line marker so we can grep logs easily
    console.log(`[LLX_PERF_START] ${label}`, nav);
  },

  mark(name: string, data?: Record<string, unknown>) {
    const store = getStore();
    const cur = store.current;
    if (!cur) return;
    cur.marks.push({ name, t: now(), data });
  },

  end(reason: string, data?: Record<string, unknown>) {
    const store = getStore();
    const cur = store.current;
    if (!cur) return;

    cur.marks.push({ name: "end", t: now(), data: { reason, ...(data ?? {}) } });
    store.history.push(cur);
    store.current = undefined;

    const rows = cur.marks.map((m, idx) => {
      const prev = cur.marks[idx - 1];
      const delta = prev ? Math.round((m.t - prev.t) * 100) / 100 : 0;
      const fromStart = Math.round((m.t - cur.startedAt) * 100) / 100;
      return {
        step: m.name,
        t: m.t,
        "+ms": delta,
        "ms_from_click": fromStart,
        data: m.data ?? {},
      };
    });

    console.log(`[LLX_PERF_END] ${cur.label} (${reason}) total=${rows[rows.length - 1]?.ms_from_click}ms`, cur);
    console.table(rows);
  },

  // Helpful for manual inspection in DevTools
  getLast() {
    const store = getStore();
    return store.history[store.history.length - 1];
  },
};
